<template>
    <div class="form-group">
        <label :for="id.ID()" :class="{'sr-only': srOnly}">
            <slot name="label">{{ label }}</slot>
        </label>
        <select 
            v-model="innerValue" 
            @change="onChange" 
            :id="id.ID()" 
            class="form-control"
            :class="{ 'is-invalid' : error }"
            :aria-label="label"
            :disabled="disabled"
        >
            <option v-if="nullable" :value="null">{{ nullLabel }}</option>
            <option
                v-for="(option, i) in options"
                :key="i"
                :value="valueCb ? valueCb(option) : optionValue ? option[optionValue] : indexIsValue ? i : option"
            >
                {{ labelCb ? labelCb(option) : optionLabel ? option[optionLabel] : option }}
            </option>
        </select>
    </div>
</template>

<script>
import id from 'src/modules/uuid.js'

export default {
    props: {
        label: {
            type: String,
            required: true,
        },
        srOnly: { // If true, hides label except as an aria-label for screen-readers.
            type: Boolean,
            default: false,
        },
        value: undefined,
        options: [Array, Object],
        optionLabel: String,    // Use with objects to specify the label field
        optionValue: String,    // Use with objects to specify the value field
        indexIsValue: {   // Set this to true if you wish to use the v-for index as the value.
            type: Boolean,
            default: false,
        },
        labelCb: Function,  // Called on the options to set their label
        valueCb: Function,  // Called on the options to set their value
        nullable: {
            type: Boolean,
            default: true,
        },
        nullLabel: {
            type: String,
            default: '',
        },
        error: Boolean,
        disabled: Boolean,
    },
    data() {
        return {
            id: new id(),
            innerValue: this.value,
        }
    },
    watch: {
    	value: function() {
    		this.innerValue = this.value;
    	},
    },
    methods: {
        onChange() {
            this.$emit('input', this.innerValue)
        }
    },
}
</script>
